module.exports = __webpack_public_path__ + "static/media/salud.6ca8c745.svg";